import { Operators, OperatorsDef, } from "@/components/fields/base/BaseSearchField";
/** Opérateur de recherche pour le champ de type bool*/
export var operators = [OperatorsDef[Operators.OPERATOR_IS]];
